export const leftPad = (str, length, char) => {
  return str.length < length ? leftPad(char + str, length, char) : str;
};
